import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import { DeltacarHistoricoFilter } from '../models/deltacar-historico-filter';
import { DeltacarHistoricoFilterService } from './deltacar-historico-filter.service';

const defaultSortParam = 'fecha';
const defaultSortDirection = 'desc';

@Injectable({
  providedIn: 'root'
})
export class DeltacarHistoricoService {
  displayedItems = [];

  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {
    this.displayedItems['checkedValues'] = 0;
    this.displayedItems['checkedItems'] = Array();
  }

  generateExcel(filter: DeltacarHistoricoFilter, sortDir: string, sortField: string): Observable<any> {
    const start = 0;
    const pageSize = 1000;

    sortField = sortField === undefined ? defaultSortParam : sortField;
    sortDir = sortDir === '' ? defaultSortDirection : sortDir;
    const params = new DeltacarHistoricoFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

    if (this.authGuard.canActivate()) {
      return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlDeltacarHistoricoExcel'],  params );
    }
  }

}
